import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { getText } from 'function/language';

/**
 * 목록 선택
 */
const Select = ({ datas, placeholder, showAll, ...props }) => {
  /* view */
  return (
    <Form.Select size="sm" {...props}>
      {placeholder && (
        <option hidden>{getText(placeholder) ?? placeholder}</option>
      )}
      {showAll && <option value="">{getText('all')}</option>}
      {datas.map(({ text, value } = {}) => (
        <option key={`datas.${value}`} value={value}>
          {getText(text) ?? text}
        </option>
      ))}
    </Form.Select>
  );
};

Select.propTypes = {
  // 목록
  datas: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
    })
  ),

  // 힌트
  placeholder: PropTypes.string,

  // 전체 선택 표시 여부
  showAll: PropTypes.bool
};
Select.defaultProps = {
  datas: [],
  showAll: false
};

export default Select;
